"use strict";
//@ts-check
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.kw_funcs = exports.ops = exports.funcs = exports.elementwise = void 0;
var basic_1 = require("./basic");
var kwargs_1 = require("./kwargs");
var dtypes_1 = require("../dtypes");
// Here, we declare only the core functions (those that are methods)
function elementwise(A, func, dtype, out) {
    if (out === void 0) { out = null; }
    A = (0, basic_1.asarray)(A);
    //@ts-ignore
    if (out)
        dtype = out.dtype;
    //@ts-ignore
    var in_buffer = (0, dtypes_1.dtype_leq)(dtype, A.dtype) ? A.flat : (0, dtypes_1.new_buffer)(A.flat, dtype);
    var out_buffer = in_buffer.map(func);
    if (out) {
        //@ts-ignore
        out.flat = out_buffer;
        return out;
    }
    return (0, basic_1.new_NDArray)(out_buffer, A.shape);
}
exports.elementwise = elementwise;
function mk_elementwise(op, dtype) {
    return function (A, out) {
        if (out === void 0) { out = null; }
        return elementwise(A, op, dtype, out);
    };
}
exports.funcs = {
    sign: mk_elementwise(Math.sign, Float64Array),
    sqrt: mk_elementwise(Math.sqrt, Float64Array),
    square: mk_elementwise(function (a) { return a * a; }, Float64Array),
    exp: mk_elementwise(Math.exp, Float64Array),
    log: mk_elementwise(Math.log, Float64Array),
    log2: mk_elementwise(Math.log2, Float64Array),
    log10: mk_elementwise(Math.log10, Float64Array),
    log1p: mk_elementwise(Math.log1p, Float64Array),
    sin: mk_elementwise(Math.sin, Float64Array),
    cos: mk_elementwise(Math.cos, Float64Array),
    tan: mk_elementwise(Math.tan, Float64Array),
    asin: mk_elementwise(Math.asin, Float64Array),
    acos: mk_elementwise(Math.acos, Float64Array),
    atan: mk_elementwise(Math.atan, Float64Array),
    cosh: mk_elementwise(Math.cosh, Float64Array),
    sinh: mk_elementwise(Math.sinh, Float64Array),
    tanh: mk_elementwise(Math.tanh, Float64Array),
    acosh: mk_elementwise(Math.acosh, Float64Array),
    asinh: mk_elementwise(Math.asinh, Float64Array),
    atanh: mk_elementwise(Math.atanh, Float64Array),
    floor: mk_elementwise(Math.floor, Float64Array),
    ceil: mk_elementwise(Math.ceil, Float64Array),
    isfinite: mk_elementwise(isFinite, Uint8Array),
    isnan: mk_elementwise(isNaN, Uint8Array),
    round: function round(arr, decimals, out) {
        if (out === void 0) { out = null; }
        if (decimals == 0)
            elementwise(arr, Math.round, Float64Array, out);
        return elementwise(arr, function (x) { return parseFloat(x.toFixed(decimals)); }, Float64Array, out);
    },
    negative: mk_elementwise(function (x) { return -x; }, Float64Array),
    bitwise_not: mk_elementwise(function (x) { return ~x; }, Float64Array),
    logical_not: mk_elementwise(function (x) { return !x; }, Uint8Array),
    valueOf: mk_elementwise(function (x) { return +x; }, Float64Array),
    abs: mk_elementwise(Math.abs, Float64Array),
};
exports.ops = __assign(__assign({}, exports.funcs), { "~": exports.funcs.bitwise_not, "not": exports.funcs.logical_not, "+": exports.funcs.valueOf, "-": exports.funcs.negative });
exports.kw_funcs = {
    sign: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.sign),
    sqrt: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.sqrt),
    square: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.square),
    exp: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.exp),
    log: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.log),
    log2: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.log2),
    log10: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.log10),
    log1p: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.log1p),
    sin: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.sin),
    cos: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.cos),
    tan: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.tan),
    asin: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.asin),
    acos: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.acos),
    atan: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.atan),
    cosh: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.cosh),
    sinh: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.sinh),
    tanh: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.tanh),
    acosh: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.acosh),
    asinh: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.asinh),
    atanh: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.atanh),
    floor: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.floor),
    ceil: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.ceil),
    negative: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.negative),
    bitwise_not: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.bitwise_not),
    logical_not: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.logical_not),
    valueOf: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.valueOf),
    abs: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.abs),
    isfinite: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.isfinite),
    isnan: kwargs_1.Func_a_out.defaultDecorator(exports.funcs.isnan),
    round: kwargs_1.Func_a_decimals_out.defaultDecorator(exports.funcs.round),
};
